import { render } from "./PR10-072322.vue?vue&type=template&id=785ea70c"
import script from "./PR10-072322.vue?vue&type=script&lang=js"
export * from "./PR10-072322.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__